var map = {
	"./bosnia-and-herzegovina-logo-icon.webp": 60294,
	"./curacao-logo-icon.webp": 96903,
	"./iraq-logo-icon.webp": 65258,
	"./jordan-logo-icon.webp": 25753,
	"./paraguay-logo-icon.webp": 17107,
	"./turkiye-logo-icon.webp": 98000,
	"./uzbekistan-logo-icon.webp": 87541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35528;